module.exports = __webpack_public_path__ + "grape_shopping_list-660fe.svg";